/* Brightline — TartarOff Pro page helpers */
(function () {
  function initStatProof() {
    var section = document.querySelector('[id*="multirow_nKiL6h"]');
    if (!section || section.querySelector('.bl-proof')) return;

    var links = Array.prototype.slice.call(section.querySelectorAll('a[href*="social-media-impact-on-smiles"]'));
    var stat = links.filter(function (a) { return /55%/.test(a.textContent); })[0];
    if (!stat) return;
    var source = links.filter(function (a) { return a !== stat; })[0];
    var statParagraph = stat.closest('p');

    var wrap = document.createElement('div');
    wrap.className = 'bl-proof';
    wrap.innerHTML =
      '<p class="bl-proof__stat"></p>' +
      '<button type="button" class="bl-proof__toggle" aria-expanded="false">See proof ▸</button>' +
      '<div class="bl-proof__box" hidden>' +
      '<p>Published by Forbes Health.</p>' +
      '<a target="_blank" rel="noopener">Forbes Health — "Social media’s impact on smiles" →</a>' +
      '</div>';
    wrap.querySelector('.bl-proof__stat').textContent = stat.textContent.trim();
    wrap.querySelector('.bl-proof__box a').href = stat.href;

    var toggle = wrap.querySelector('.bl-proof__toggle');
    var box = wrap.querySelector('.bl-proof__box');
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      box.hidden = open;
      wrap.classList.toggle('is-open', !open);
    });

    statParagraph.replaceWith(wrap);
    // The separate "source:" line now lives inside the proof box
    if (source && source.closest('p')) source.closest('p').remove();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStatProof);
  } else {
    initStatProof();
  }
})();
